<template lang="pug">
v-layout(align-start)
      v-flex
        v-data-table.elevation-1(:headers='headers' item-key='empresas' :items='empresas' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
          template(v-slot:top)
            v-toolbar(flat color='primary' dark)
              v-toolbar-title Empresas
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
              v-spacer
              v-dialog(v-model='dialog' scrollable persistent max-width='80%')
                template(v-slot:activator='{ on }')
                  v-btn.mx-2( fab dark small color='success' v-on='on')
                    v-icon(dark) mdi-plus
                v-card(color='grey_1')
                  v-app-bar(dark color='primary')
                    span.headline {{ formTitle }}
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Información de la empresa
                          v-card-text
                            v-row(dense)
                              v-col(cols='6' sm='6' md='4')
                                v-text-field(v-model='form.nombre' id="nombreEmpresa" label='Nombre' dense outlined)
                              v-col(cols='6' sm='6' md='4')
                                v-text-field(v-model='form.rif' id="rifEmpresa" label='Rif' dense outlined)
                              v-col(cols='6' sm='6' md='4')
                                v-text-field(v-model='form.telf' id="tlfEmpresa" v-mask="'(####)###-##-##'" label='Telefono' dense outlined)
                              v-col(cols='6' sm='6' md='6')
                                v-text-field(v-model='form.paginaWeb' id="webEmpresa" v-on:blur='validarWeb' label='Pagina Web' hint='www.ejemplo.com' dense outlined)
                              v-col(cols='6' sm='6' md='6')
                                v-text-field(v-model='form.correo' id="correoEmpresa" label='Correo' hint='ejemplo@ejemplo.com' dense outlined)
                              v-col(cols='6' sm='6' md='12')
                                v-textarea(
                                  auto-grow,
                                  v-model='form.dir',
                                  label='Direccion',
                                  dense,
                                  outlined,
                                  v-uppercase)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title(style='color: black') Logo
                            v-card-text
                              v-row(dense class='d-flex justify-center')
                                v-col(cols='12' sm='12' md='4')
                                  img(:src='ruta + img' v-if='img && !form.imagen.imageUrl' style='width:310px;height:auto')
                                  img(:src='form.imagen.imageUrl' v-if='form.imagen.imageUrl' style='width:310px;height:auto')
                                v-col(cols='12' sm='12' md='12')
                                  v-text-field(style='height: 56px;margin: 0px 0px 10px;' rounded label='Seleccione el logo' @click='pickFile' v-model='img' prepend-inner-icon='attach_file' dense outlined)
                                  input(type='file' style='display: none;' ref='image' accept='image/*' @change='onFilePicked')
                  v-card-actions
                    v-spacer
                    v-btn(color='error' small dark @click='close')
                      v-icon mdi-close
                      | Cancelar
                    v-btn(color='success' small dark @click='save')
                      v-icon mdi-content-save
                      | Guardar
              // view show
              v-dialog(v-model='dialogShow' scrollable persistent max-width='80%')
                v-card(color='grey_1')
                  v-app-bar(dark color='primary')
                    span.headline {{ formTitleShow }}
                  v-card-text
                    v-row(dense)
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title Información de la empresa
                            v-card-text
                              v-row(dense)
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense readonly outlined v-model='form.nombre' label='Nombre')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense readonly outlined v-model='form.rif' label='Rif')
                                v-col(cols='6' sm='6' md='4')
                                  v-text-field(dense readonly outlined v-model='form.telf' label='Telefono')
                                v-col(cols='6' sm='6' md='6')
                                  v-text-field#webEmpresa(dense readonly outlined v-model='form.paginaWeb' label='Pagina Web')
                                v-col(cols='6' sm='6' md='6')
                                  v-text-field#correo2(dense readonly outlined v-model='form.correo' label='Correo')
                                v-col(cols='6' sm='6' md='12')
                                  v-textarea(auto-grow dense readonly outlined v-model='form.dir' label='Direccion')
                      v-col(cols='12')
                        v-card(color='white')
                          v-card-subtitle.title Logo
                          v-card-text
                            v-row(dense class='d-flex justify-center')
                              v-col(cols='12' sm='12' md='4')
                                img(:src='ruta + img' v-if='img && !form.imagen.imageUrl' style='width:310px;height:auto')
                  v-card-actions
                    v-spacer
                    v-btn(color='error' small dark @click='close')
                      v-icon mdi-close
                      | Salir
          template(v-slot:item.action='{ item }')
            v-icon.mr-2(color='primary_2' @click='ShowItem(item)') mdi-eye
            v-icon.mr-2( color='warning' @click='editItem(item)') mdi-pencil
            v-icon( color='error' @click='deleteItem(item)') mdi-delete
</template>

<script>
import Api from '@/services/methods'
import { server, port } from '../services/environment'
import { EventBus } from '../Events'
export default {
  data: () => ({
    ruta: server + ':' + port,
    dialog: false,
    dialogShow: false,
    loading: true,
    headers: [
      { text: 'Rif', align: 'left', value: 'rif' },
      { text: 'Nombre', value: 'nombre', align: 'center' },
      { text: 'Correo', value: 'correo', align: 'center' },
      { text: 'Telefono', value: 'telf', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    permisosRuta: {},
    empresas: [],
    img: '',
    master: '',
    editedIndex: -1,
    form: {
      rif: '',
      dir: '',
      paginaWeb: '',
      nombre: '',
      correo: '',
      telf: '',
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
    },
    defaultForm: {
      nombre: '',
      rif: '',
      dir: '',
      paginaWeb: '',
      correo: '',
      telf: '',
      imagen: {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Empresa'
        : 'Modificar Empresa'
    },
    formTitleShow () {
      return 'Información de la empresa'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogShow (val) {
      val || this.close()
    }
  },

  created () {
    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
    } else {
      this.master = this.$store.state.usuario._id
    }
    this.initialize()
  },

  methods: {

    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        let peso = false
        for (let j = 0; j < files.length; j++) {
          if (files[j].size > 4194304) {
            peso = true
          }
        }
        if (peso === false) {
          this.form.imagen.imageName = files[0].name
          if (this.form.imagen.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.form.imagen.imageUrl = fr.result
            this.form.imagen.imageFile = files[0]
          })
        } else {
          this.$swal.fire(
            'Oops...',
            'Error encontrado, la imagen debe pesar menos de 4MB.',
            'error'
          )
          this.files = []
          this.form.imagen = []
        }
      } else {
        this.form.imagen.imageName = ''
        this.form.imagen.imageFile = ''
        this.form.imagen.imageUrl = ''
      }
    },

    initialize () {
      this.form.imagen.imageName = ''
      this.form.imagen.imageFile = ''
      this.form.imagen.imageUrl = ''
      this.editedIndex = -1
      this.listarEmpresas()
    },

    listarEmpresas () {
      Api.get('/empresa/master/' + this.master).then((response) => {
        this.empresas = response.data
        this.loading = false
      })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    editItem (item) {
      this.editedIndex = this.empresas.indexOf(item)
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key]
      })
      this.form.imagen = {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
      if (item.logo) {
        this.img = item.logo
      }
      this.form._id = item._id
      this.dialog = true
    },

    ShowItem (item) {
      this.editedIndex = this.empresas.indexOf(item)
      this.dialogShow = true
      this.editedItem = Object.assign({}, item)
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key]
      })
      this.form.imagen = {
        imageName: '',
        imageUrl: '',
        imageFile: ''
      }
      if (item.logo) {
        this.img = item.logo
      }
      this.form._id = item._id
    },

    deleteItem (item) {
      const index = this.empresas.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal.fire('Borrado!', 'Su registro fue borrado.', 'success')
          this.empresas.splice(index, 1)
          Api.delete('/empresa/' + item._id).then(response => {
          })
        }
      })
    },

    close () {
      this.dialog = false
      this.dialogShow = false
      setTimeout(() => {
        this.form.imagen.imageName = ''
        this.form.imagen.imageFile = ''
        this.form.imagen.imageUrl = ''
        this.img = ''
        this.form = Object.assign({}, this.defaultForm)
        this.editedIndex = -1
      }, 300)
    },

    validarCampos () {
      if (this.form.nombre === '' ||
          this.form.dir === '' ||
          this.form.rif === '' ||
          this.form.paginaWeb === '' ||
          this.form.correo === '' ||
          this.form.telf === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    validarCorreo () {
      const validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!validate.test(this.form.correo)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'El correo ingresado no cumple con el debido formato'
        })
        return true
      }
      return false
    },

    validarWeb () {
      const validate = /^(www|http:\/\/)(.*\.(com$|net$|org$))/
      if (!validate.test(this.form.paginaWeb)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'La pagina web ingresada no cumple con el debido formato'
        })
        return true
      }
      return false
    },

    validarTelefono () {
      if (this.form.telf.length !== 15) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'El campo de telefono debe tener 15 digitos, por favor verifique'
        })
        return true
      } else {
        return false
      }
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
      if (!this.validarCampos() && !this.validarTelefono() && !this.validarWeb() && !this.validarCorreo()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.loading = true
        const data = new FormData()
        this.form.master = this.master
        Object.keys(this.form).map(key => {
          if (Array.isArray(this.form[key])) {
            this.form[key].forEach(val => {
              if (typeof val === 'object' && val !== null) {
                return data.append(`${key}[]`, JSON.stringify(val))
              }
              return data.append(`${key}[]`, val)
            })
          } else if (
            typeof this.form[key] === 'object' &&
            this.form[key] !== null
          ) {
            return data.append(key, JSON.stringify(this.form[key]))
          } else {
            return data.append(key, this.form[key])
          }
        })
        if (this.form.imagen.imageFile) {
          data.append('imagen', this.form.imagen.imageFile)
        }
        if (this.editedIndex > -1) {
          Api.put('/empresa', data).then(res => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.$store.dispatch('logo64', res.data.logo64.base64)
            Api.post('login', {correo: this.$store.state.usuario.nombre, contrasenna: this.$store.state.usuario.contrasenna})
            .then(res => {
              this.$store.dispatch('empresaSelec', res.data.usuario.Empresa)
              this.$store.dispatch('usuario', res.data.usuario)
              window.location.reload()
            })
            .catch(error => console.log(error))
          })
          .catch(error => { 
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
        } else {
          Api.post('empresa/image', data).then(response => {
            this.$swal({
              icon: 'success',
              title: 'Inclusion exitosa',
              text: 'Todos los datos han sido guardados'
            })
            this.listarEmpresas()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
          this.initialize()
        }
        this.close()
      }
    }
  }
}
</script>
